/*
 * Copyright (c) 2026 CalAmp Corp. All Rights Reserved
 */
import React from 'react';

/**
 * Defines the prop types for the `ResellerFontLoader` component, which accepts
 * and optional `url` prop to specify the location of the fonts CSS file.
 */
interface ResellerFontLoaderProps {
  url?: string;
}

/**
 * Loads reseller-specific fonts from the provided URL.
 *
 * ```typescript
 *  import ResellerFontLoader from './ResellerFontLoader';
 *
 *  <ResellerFontLoader url="/fonts/fonts.css" />
 * ```
 *
 * @param   url The URL to the reseller fonts CSS file (default: '/fonts/fonts.css')
 * @returns `null`
 */
const ResellerFontLoader = (
  {url = '/fonts/fonts.css'}: ResellerFontLoaderProps) => {
  React.useEffect(() => {
    const link = document.createElement('link');
    link.rel = 'stylesheet';
    link.href = url;
    document.head.appendChild(link);
  }, [url]);
  return null;
};

export default React.memo(ResellerFontLoader);
